<template>
  <div class="notif-count">
    <span>{{ value }}</span>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Notification count display that automatically resizes the circle
 * depending on the number
 * ==================================================================================
 **/
export default {
  props: ['value']
}
</script>
<style scoped lang="scss">
.notif-count {
  display: inline-block;
  border-radius: 50%;
  min-width: 20px;
  min-height: 20px;
  padding: 5px;
  text-align: center;
  box-sizing: content-box;
  white-space: nowrap;
  background: var(--brand-green);

  font-weight: bold;
  line-height: 1;
  color: #fff;

  &:before {
    height: 0;
    content: '';
    display: inline-block;
    vertical-align: middle;
    padding-top: 100%;
  }

  span {
    display: inline-block;
    vertical-align: middle;
  }
}
</style>
